import type {FC} from 'react';
import LazyLoading from '@/components/common/LazyLoading';
import InventoryPlotDetail from '@/components/InventoryPlotDetail';
import useController from '@/views/InventoryPlot/Detail/controller';

const InventoryPlotDetailView: FC = () => {
  const {
    forestMass,
    forestMassSpecies,
    inventoryPlots,
    inventoryPlot,
    inventoryStems,
    lidarTechnologies,
    slamPointCloud,
    species,
    loading,
    userPermissions,
    onBack,
    onInventoryPlotSelect,
    onDeleteSlamPointCloud,
    onUploadSlamPointCloud,
    onDownloadSlamPointCloud,
    onReuploadSlamPointCloud,
    onAppraiserWeightChange,
  } = useController();

  if (!inventoryPlots || !species || !forestMass || !inventoryStems || !inventoryPlot) return;

  return (
    <>
      {loading && <LazyLoading />}
      <InventoryPlotDetail
        inventoryPlots={inventoryPlots}
        species={species}
        forestMass={forestMass}
        lidarTechnologies={lidarTechnologies}
        slamPointCloud={slamPointCloud}
        permissions={userPermissions}
        onBack={onBack}
        onInventoryPlotSelect={onInventoryPlotSelect}
        inventoryStems={inventoryStems}
        selectedInventoryPlot={inventoryPlot}
        forestMassSpecies={forestMassSpecies}
        onDeleteSlamPointCloud={onDeleteSlamPointCloud}
        onUploadSlamPointCloud={onUploadSlamPointCloud}
        onDownloadSlamPointCloud={onDownloadSlamPointCloud}
        onReuploadSlamPointCloud={onReuploadSlamPointCloud}
        onAppraiserWeightChange={onAppraiserWeightChange}
      />
    </>
  );
};

export default InventoryPlotDetailView;
